export default __webpack_public_path__ + "static/media/icon-clock.ff1710f2.svg";